// StyledSubmitButtonWrapper.js
import styled from "styled-components";

const SubmitButtonWrapper = styled.div`
text-align: ${(props) => props.theme.submitButtonAlign};
`;

export default SubmitButtonWrapper;